<style>
	:global(body) {
		padding: 0;
		font-family: 'IBM Plex Sans Condensed', sans-serif;
	}

	#holder {
		width: 100%;
		height: 100%;
		display: flex;
		position: absolute;
		flex-direction: column;
	}

	#topbar {
		font-size: 13px !important;
		background-color: black;
		color: hotpink;
		padding-top: 10px;
		padding-bottom: 6px;
		width: 100%;
		display: flex;
	}

	#stories {
		max-height: 100%;
		overflow: hidden;
	}

	input {
		background-color: rgb(44, 44, 44);
		border: none;
		color: white;
		width: 300px;
	}

	#logo {
		padding-top: 5px;
		font-weight: bold;
		padding-right: 15px;
		padding-left: 15px;
	}

	#info {
		padding-top: 5px;
		text-align: right;
		flex: 1;
		padding-right: 20px;
	}

	#alldone {
		width: 100%;
		padding-top: 10%;
		text-align: center;
		font-size: 24px;
		padding-bottom: 20%;
	}

	#pro {
		margin-top: 30px;
		font-size: 14px;
		color: grey;
		text-align: left;
		max-width: 400px;
		display: inline-block;
	}

	#suggestions {
		padding-top: 20px;
	}

	.suggestion {
		background-color: rgb(65, 65, 65);
		font-size: 18px;
		padding: 5px;
		color: white;
		display: inline-block;
		border-radius: 5px;
		margin: 0px;
		margin-top: 5px;
		margin-left: 5px;
	}

	.suggestion:hover {
		background-color: black;
		cursor: pointer;
	}

	button {
		color: white;
		background-color: rgb(58, 58, 58);
		border: none;
		padding: 4px;
	}

	#buy-pro {
		border-radius: 5px;
		font-size: 18px;
		padding: 5px;
		color: grey;
		background-color: gainsboro;
		cursor: pointer;
	}

	#buy-pro:hover {
		background-color: black;
		color: white;
	}

	#mobile-message {
		padding: 10px;
	}

	#mobile-bar {
		background-color: black;
		color: white;
		padding: 10px;
		font-style: italic;
	}

</style>

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Condensed&display=swap" rel="stylesheet"> 

<script>
	import { onMount } from 'svelte';
	import Story from './Story.svelte'
	$: stories = []
	let toDelete = {}
	let subreddit = ''
	let infoText = 'Press Space to Clear Read Stories!'
	let storiesDiv;
	let show = true;

	onMount(() => {
		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
 			show = false;
		} else {
			show = true;
		}
	})

	window.addEventListener("keydown", (e => {
		if(e.key===' ') {
			e.preventDefault();
			stories = stories.filter(story => {
				if(story.data.id in toDelete) {
					return false
				}
				return true
			})
			infoText = `Cleared ${Object.keys(toDelete).length} Stories. ${stories.length} Left.`
			toDelete = {}
		}
		if(e.key==='Enter') {
			load()
			e.target.blur();
		}
	}));
	
	let load = () => {
		fetch(`https://old.reddit.com/r/${subreddit}/hot.json?limit=1000`)
		.then(r => r.json())
		.then(j => {
			stories = stories.concat(j.data.children)
			infoText = `Added ${j.data.children.length} stories from '${subreddit}'`;
			subreddit = ''
		})
	}

	let buy = (e) => {
		window.location.href = '/pro'
	}

	let deleteFunction = (story) => {
		toDelete[story] = true
	}
</script>

{#if show}
	<div id="holder">
		<div id="topbar">
			<div id="logo">- Siftedit -</div>
			<div id="subreddit">
				<input bind:value={subreddit} placeholder="Enter Subreddit Name..."/>
				<button on:click={load}>Add Stories</button>
			</div>
			<div id="info">{infoText}</div>
		</div>
		<div id="stories" bind:this={storiesDiv}>
			{#if stories.length===0}
			<div id="alldone">
				<div>
					<h2>SiftedIt - Experimental UI For Sifting Through Thousands of Stories At Record Speed</h2>
					<ol style="text-align: left; display: inline-block">
						<li>Use Above Search Box to Add Stories From Desired Sub-Reddits.</li>
						<li>Move Cursor Over Stories to 'Mark' Them. (Click To Open In New Tab)</li>
						<li>Press Space to Clear 'Marked' Stories.</li>
					</ol>
				</div>
				<br>
				Quick Add:
				<div id="suggestions">
					<div class="suggestion" on:click={() => { subreddit='apple'; load() }}>
						r/apple
					</div>
					<div class="suggestion" on:click={() => { subreddit='teslamotors'; load() }}>
						r/teslamotors
					</div>
					<div class="suggestion" on:click={() => { subreddit='worldnews'; load() }}>
						r/worldnews
					</div>
					<div class="suggestion" on:click={() => { subreddit='movies'; load() }}>
						r/movies
					</div>
					<div class="suggestion" on:click={() => { subreddit='sports'; load() }}>
						r/sports
					</div>
					<div class="suggestion" on:click={() => { subreddit='programming'; load() }}>
						r/programming
					</div>
					<div class="suggestion" on:click={() => { subreddit='linux'; load() }}>
						r/linux
					</div>
					<div class="suggestion" on:click={() => { subreddit='technology'; load() }}>
						r/technology
					</div>
					<div class="suggestion" on:click={() => { subreddit='television'; load() }}>
						r/television
					</div>
					<div class="suggestion" on:click={() => { subreddit='hackernews'; load() }}>
						r/hackernews
					</div>
				</div>
				<br>
				<div id="pro">
					<button id="buy-pro" on:click={buy}>Siftedit Pro with RSS Support for  $10 / Month</button>
				</div>
			</div>
			{:else}
			{#each stories as s}
				<Story story={s.data} deleteStory={deleteFunction}></Story>
			{/each}
			{/if}
		</div>
	</div>
{:else}
	<div id="mobile-bar"><b>SiftedIt</b> - Experimental UI For Sifting Through Thousands of Stories At Record Speed</div>
	<div id="mobile-message">
		<h1>Desktop-Only Site</h1>
		<p>
			<b>SiftedIt</b> is a Desktop-Only Tool as it heavily relies on 'mouse-over' gestures with key presses to enable a 'mark-and-sweep' UI metaphor. This works as follows:
		</p>
		<ol style="text-align: left; display: inline-block">
			<li>Search Box is Used To Add Stories From Desired Sub-Reddits.</li>
			<li>Cursor Over Stories 'Marks' Them. (Click To Open In New Tab)</li>
			<li>Space Pressed to Clear 'Marked' Stories.</li>
		</ol>
		<p>
			Please visit <a href="https://siftedit.xantasoft.com">siftedit.xantasoft.com</a> with a desktop browser to try it out.
		</p>
	</div>
{/if}